var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((10),function(i){return _c('v-col',{key:i,attrs:{"cols":"6","sm":"3"}},[_c('v-skeleton-loader',{attrs:{"type":"card"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }